// extracted by mini-css-extract-plugin
module.exports = {"iconsListItem":"PromoIcon_iconsListItem__f3Xfl"};